/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DestroyDiscardedItemNodesParams,
  DestroyItemNodesParams,
  DiscardItemNodesParams,
  DuplicateItemNodeParams,
  ItemNode,
  ItemNodeActionInput,
  ItemNodeAiSources,
  ItemNodeAiSourcesUpdateInput,
  ItemNodeCreateInput,
  ItemNodeMoveInput,
  ListItemNodesParams,
  ListReusableAiSourcesParams,
  PaginatedAiSources,
  PaginatedItemNodes,
  SchemaValidationErrorResponse,
  SearchItemNodesParams,
  UndiscardItemNodesParams,
  UpdateItemNodeInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List reusable AI Sources
 */
export const listReusableAiSources = (
    params?: MaybeRefOrGetter<ListReusableAiSourcesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiSources>(
      {url: `/ai_sources`, method: 'GET',
        params, signal
    },
      );
    }




export const getListReusableAiSourcesQueryKey = (params?: MaybeRefOrGetter<ListReusableAiSourcesParams>,) => {
    return [
    'ai_sources', ...(params ? [params] : [])
    ] as const;
    }


export const getListReusableAiSourcesQueryOptions = <TData = Awaited<ReturnType<typeof listReusableAiSources>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListReusableAiSourcesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReusableAiSources>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListReusableAiSourcesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReusableAiSources>>> = ({ signal }) => listReusableAiSources(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReusableAiSources>>, TError, TData>
}

export type ListReusableAiSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listReusableAiSources>>>
export type ListReusableAiSourcesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List reusable AI Sources
 */

export function useListReusableAiSources<TData = Awaited<ReturnType<typeof listReusableAiSources>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListReusableAiSourcesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReusableAiSources>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReusableAiSourcesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Item Node
 */
export const createItemNode = (
    itemNodeCreateInput: MaybeRefOrGetter<ItemNodeCreateInput>,
 signal?: AbortSignal
) => {
      itemNodeCreateInput = toValue(itemNodeCreateInput);

      return axiosClient<ItemNode>(
      {url: `/item_nodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemNodeCreateInput, signal
    },
      );
    }




export const getCreateItemNodeMutationKey = () => ['createItemNode'] as const;

export const getCreateItemNodeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemNode>>, TError,CreateItemNodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createItemNode>>, TError,CreateItemNodeMutationVariables, TContext> => {

const mutationKey = getCreateItemNodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItemNode>>, CreateItemNodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createItemNode(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateItemNodeMutationResult = NonNullable<Awaited<ReturnType<typeof createItemNode>>>
    export type CreateItemNodeMutationBody = ItemNodeCreateInput
    export type CreateItemNodeMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateItemNodeMutationVariables = {data: ItemNodeCreateInput}

    /**
 * @summary Create Item Node
 */
export const useCreateItemNode = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemNode>>, TError,CreateItemNodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createItemNode>>,
        TError,
        CreateItemNodeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateItemNodeMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Item Nodes
 */
export const listItemNodes = (
    params?: MaybeRefOrGetter<ListItemNodesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedItemNodes>(
      {url: `/item_nodes`, method: 'GET',
        params, signal
    },
      );
    }




export const getListItemNodesQueryKey = (params?: MaybeRefOrGetter<ListItemNodesParams>,) => {
    return [
    'item_nodes', ...(params ? [params] : [])
    ] as const;
    }


export const getListItemNodesQueryOptions = <TData = Awaited<ReturnType<typeof listItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItemNodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListItemNodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listItemNodes>>> = ({ signal }) => listItemNodes(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listItemNodes>>, TError, TData>
}

export type ListItemNodesQueryResult = NonNullable<Awaited<ReturnType<typeof listItemNodes>>>
export type ListItemNodesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Item Nodes
 */

export function useListItemNodes<TData = Awaited<ReturnType<typeof listItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItemNodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListItemNodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy item nodes
 */
export const destroyItemNodes = (
    itemNodeActionInput: MaybeRefOrGetter<ItemNodeActionInput>,
    params?: MaybeRefOrGetter<DestroyItemNodesParams>,
 signal?: AbortSignal
) => {
      itemNodeActionInput = toValue(itemNodeActionInput);
params = toValue(params);

      return axiosClient<void>(
      {url: `/item_nodes/destroy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemNodeActionInput,
        params, signal
    },
      );
    }




export const getDestroyItemNodesMutationKey = () => ['destroyItemNodes'] as const;

export const getDestroyItemNodesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyItemNodes>>, TError,DestroyItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyItemNodes>>, TError,DestroyItemNodesMutationVariables, TContext> => {

const mutationKey = getDestroyItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyItemNodes>>, DestroyItemNodesMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  destroyItemNodes(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof destroyItemNodes>>>
    export type DestroyItemNodesMutationBody = ItemNodeActionInput
    export type DestroyItemNodesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DestroyItemNodesMutationVariables = {data: ItemNodeActionInput;params?: DestroyItemNodesParams}

    /**
 * @summary Destroy item nodes
 */
export const useDestroyItemNodes = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyItemNodes>>, TError,DestroyItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyItemNodes>>,
        TError,
        DestroyItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyItemNodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Discard item nodes
 */
export const discardItemNodes = (
    itemNodeActionInput: MaybeRefOrGetter<ItemNodeActionInput>,
    params?: MaybeRefOrGetter<DiscardItemNodesParams>,
 signal?: AbortSignal
) => {
      itemNodeActionInput = toValue(itemNodeActionInput);
params = toValue(params);

      return axiosClient<void>(
      {url: `/item_nodes/discard`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemNodeActionInput,
        params, signal
    },
      );
    }




export const getDiscardItemNodesMutationKey = () => ['discardItemNodes'] as const;

export const getDiscardItemNodesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardItemNodes>>, TError,DiscardItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof discardItemNodes>>, TError,DiscardItemNodesMutationVariables, TContext> => {

const mutationKey = getDiscardItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discardItemNodes>>, DiscardItemNodesMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  discardItemNodes(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscardItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof discardItemNodes>>>
    export type DiscardItemNodesMutationBody = ItemNodeActionInput
    export type DiscardItemNodesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DiscardItemNodesMutationVariables = {data: ItemNodeActionInput;params?: DiscardItemNodesParams}

    /**
 * @summary Discard item nodes
 */
export const useDiscardItemNodes = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardItemNodes>>, TError,DiscardItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof discardItemNodes>>,
        TError,
        DiscardItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getDiscardItemNodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy discarded item nodes (empty trash)
 */
export const destroyDiscardedItemNodes = (
    params?: MaybeRefOrGetter<DestroyDiscardedItemNodesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<void>(
      {url: `/item_nodes/discarded`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDestroyDiscardedItemNodesMutationKey = () => ['destroyDiscardedItemNodes'] as const;

export const getDestroyDiscardedItemNodesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDiscardedItemNodes>>, TError,DestroyDiscardedItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyDiscardedItemNodes>>, TError,DestroyDiscardedItemNodesMutationVariables, TContext> => {

const mutationKey = getDestroyDiscardedItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyDiscardedItemNodes>>, DestroyDiscardedItemNodesMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  destroyDiscardedItemNodes(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyDiscardedItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof destroyDiscardedItemNodes>>>

    export type DestroyDiscardedItemNodesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DestroyDiscardedItemNodesMutationVariables = {params?: DestroyDiscardedItemNodesParams}

    /**
 * @summary Destroy discarded item nodes (empty trash)
 */
export const useDestroyDiscardedItemNodes = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDiscardedItemNodes>>, TError,DestroyDiscardedItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyDiscardedItemNodes>>,
        TError,
        DestroyDiscardedItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyDiscardedItemNodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Move item nodes
 */
export const moveItemNodes = (
    itemNodeMoveInput: MaybeRefOrGetter<ItemNodeMoveInput>,
 signal?: AbortSignal
) => {
      itemNodeMoveInput = toValue(itemNodeMoveInput);

      return axiosClient<void>(
      {url: `/item_nodes/move`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemNodeMoveInput, signal
    },
      );
    }




export const getMoveItemNodesMutationKey = () => ['moveItemNodes'] as const;

export const getMoveItemNodesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveItemNodes>>, TError,MoveItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveItemNodes>>, TError,MoveItemNodesMutationVariables, TContext> => {

const mutationKey = getMoveItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveItemNodes>>, MoveItemNodesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  moveItemNodes(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof moveItemNodes>>>
    export type MoveItemNodesMutationBody = ItemNodeMoveInput
    export type MoveItemNodesMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type MoveItemNodesMutationVariables = {data: ItemNodeMoveInput}

    /**
 * @summary Move item nodes
 */
export const useMoveItemNodes = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveItemNodes>>, TError,MoveItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveItemNodes>>,
        TError,
        MoveItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getMoveItemNodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Search Items
 */
export const searchItemNodes = (
    params?: MaybeRefOrGetter<SearchItemNodesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedItemNodes>(
      {url: `/item_nodes/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchItemNodesQueryKey = (params?: MaybeRefOrGetter<SearchItemNodesParams>,) => {
    return [
    'item_nodes','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchItemNodesQueryOptions = <TData = Awaited<ReturnType<typeof searchItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<SearchItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchItemNodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchItemNodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchItemNodes>>> = ({ signal }) => searchItemNodes(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchItemNodes>>, TError, TData>
}

export type SearchItemNodesQueryResult = NonNullable<Awaited<ReturnType<typeof searchItemNodes>>>
export type SearchItemNodesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Search Items
 */

export function useSearchItemNodes<TData = Awaited<ReturnType<typeof searchItemNodes>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<SearchItemNodesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchItemNodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchItemNodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Undiscard item nodes
 */
export const undiscardItemNodes = (
    itemNodeActionInput: MaybeRefOrGetter<ItemNodeActionInput>,
    params?: MaybeRefOrGetter<UndiscardItemNodesParams>,
 signal?: AbortSignal
) => {
      itemNodeActionInput = toValue(itemNodeActionInput);
params = toValue(params);

      return axiosClient<void>(
      {url: `/item_nodes/undiscard`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemNodeActionInput,
        params, signal
    },
      );
    }




export const getUndiscardItemNodesMutationKey = () => ['undiscardItemNodes'] as const;

export const getUndiscardItemNodesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undiscardItemNodes>>, TError,UndiscardItemNodesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof undiscardItemNodes>>, TError,UndiscardItemNodesMutationVariables, TContext> => {

const mutationKey = getUndiscardItemNodesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undiscardItemNodes>>, UndiscardItemNodesMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  undiscardItemNodes(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UndiscardItemNodesMutationResult = NonNullable<Awaited<ReturnType<typeof undiscardItemNodes>>>
    export type UndiscardItemNodesMutationBody = ItemNodeActionInput
    export type UndiscardItemNodesMutationError = ErrorType<void>
    export type UndiscardItemNodesMutationVariables = {data: ItemNodeActionInput;params?: UndiscardItemNodesParams}

    /**
 * @summary Undiscard item nodes
 */
export const useUndiscardItemNodes = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undiscardItemNodes>>, TError,UndiscardItemNodesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof undiscardItemNodes>>,
        TError,
        UndiscardItemNodesMutationVariables,
        TContext
      > => {
      return useMutation(getUndiscardItemNodesMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Item Node
 */
export const showItemNode = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ItemNode>(
      {url: `/item_nodes/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowItemNodeQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'item_nodes',id
    ] as const;
    }


export const getShowItemNodeQueryOptions = <TData = Awaited<ReturnType<typeof showItemNode>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showItemNode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowItemNodeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showItemNode>>> = ({ signal }) => showItemNode(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showItemNode>>, TError, TData>
}

export type ShowItemNodeQueryResult = NonNullable<Awaited<ReturnType<typeof showItemNode>>>
export type ShowItemNodeQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show Item Node
 */

export function useShowItemNode<TData = Awaited<ReturnType<typeof showItemNode>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showItemNode>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowItemNodeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Item Node
 */
export const updateItemNode = (
    id: MaybeRefOrGetter<string>,
    updateItemNodeInput: MaybeRefOrGetter<UpdateItemNodeInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
updateItemNodeInput = toValue(updateItemNodeInput);

      return axiosClient<ItemNode>(
      {url: `/item_nodes/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateItemNodeInput, signal
    },
      );
    }




export const getUpdateItemNodeMutationKey = () => ['updateItemNode'] as const;

export const getUpdateItemNodeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItemNode>>, TError,UpdateItemNodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateItemNode>>, TError,UpdateItemNodeMutationVariables, TContext> => {

const mutationKey = getUpdateItemNodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItemNode>>, UpdateItemNodeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateItemNode(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemNodeMutationResult = NonNullable<Awaited<ReturnType<typeof updateItemNode>>>
    export type UpdateItemNodeMutationBody = UpdateItemNodeInput
    export type UpdateItemNodeMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateItemNodeMutationVariables = {id: string;data: UpdateItemNodeInput}

    /**
 * @summary Update Item Node
 */
export const useUpdateItemNode = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItemNode>>, TError,UpdateItemNodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateItemNode>>,
        TError,
        UpdateItemNodeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateItemNodeMutationOptions(options), queryClient);
    }
    /**
 * @summary Generate AI preview image
 */
export const generateItemNodeAiPreviewImage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/item_nodes/${id}/ai_preview_image`, method: 'POST', signal
    },
      );
    }




export const getGenerateItemNodeAiPreviewImageMutationKey = () => ['generateItemNodeAiPreviewImage'] as const;

export const getGenerateItemNodeAiPreviewImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateItemNodeAiPreviewImage>>, TError,GenerateItemNodeAiPreviewImageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateItemNodeAiPreviewImage>>, TError,GenerateItemNodeAiPreviewImageMutationVariables, TContext> => {

const mutationKey = getGenerateItemNodeAiPreviewImageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateItemNodeAiPreviewImage>>, GenerateItemNodeAiPreviewImageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  generateItemNodeAiPreviewImage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateItemNodeAiPreviewImageMutationResult = NonNullable<Awaited<ReturnType<typeof generateItemNodeAiPreviewImage>>>

    export type GenerateItemNodeAiPreviewImageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type GenerateItemNodeAiPreviewImageMutationVariables = {id: string}

    /**
 * @summary Generate AI preview image
 */
export const useGenerateItemNodeAiPreviewImage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateItemNodeAiPreviewImage>>, TError,GenerateItemNodeAiPreviewImageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof generateItemNodeAiPreviewImage>>,
        TError,
        GenerateItemNodeAiPreviewImageMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateItemNodeAiPreviewImageMutationOptions(options), queryClient);
    }
    /**
 * @summary Duplicate Item Node
 */
export const duplicateItemNode = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<DuplicateItemNodeParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<void>(
      {url: `/item_nodes/${id}/duplicate`, method: 'POST',
        params, signal
    },
      );
    }




export const getDuplicateItemNodeMutationKey = () => ['duplicateItemNode'] as const;

export const getDuplicateItemNodeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateItemNode>>, TError,DuplicateItemNodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof duplicateItemNode>>, TError,DuplicateItemNodeMutationVariables, TContext> => {

const mutationKey = getDuplicateItemNodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateItemNode>>, DuplicateItemNodeMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  duplicateItemNode(id,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateItemNodeMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateItemNode>>>

    export type DuplicateItemNodeMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DuplicateItemNodeMutationVariables = {id: string;params?: DuplicateItemNodeParams}

    /**
 * @summary Duplicate Item Node
 */
export const useDuplicateItemNode = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateItemNode>>, TError,DuplicateItemNodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof duplicateItemNode>>,
        TError,
        DuplicateItemNodeMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateItemNodeMutationOptions(options), queryClient);
    }
    /**
 * @summary Toggle Template Status
 */
export const toggleItemNodeTemplate = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/item_nodes/${id}/toggle_template`, method: 'PUT', signal
    },
      );
    }




export const getToggleItemNodeTemplateMutationKey = () => ['toggleItemNodeTemplate'] as const;

export const getToggleItemNodeTemplateMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleItemNodeTemplate>>, TError,ToggleItemNodeTemplateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleItemNodeTemplate>>, TError,ToggleItemNodeTemplateMutationVariables, TContext> => {

const mutationKey = getToggleItemNodeTemplateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleItemNodeTemplate>>, ToggleItemNodeTemplateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  toggleItemNodeTemplate(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleItemNodeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof toggleItemNodeTemplate>>>

    export type ToggleItemNodeTemplateMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ToggleItemNodeTemplateMutationVariables = {id: string}

    /**
 * @summary Toggle Template Status
 */
export const useToggleItemNodeTemplate = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleItemNodeTemplate>>, TError,ToggleItemNodeTemplateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleItemNodeTemplate>>,
        TError,
        ToggleItemNodeTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getToggleItemNodeTemplateMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Item Node AI Sources
 */
export const getItemNodeAiSources = (
    itemNodeId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      itemNodeId = toValue(itemNodeId);

      return axiosClient<ItemNodeAiSources>(
      {url: `/item_nodes/${itemNodeId}/ai_sources`, method: 'GET', signal
    },
      );
    }




export const getGetItemNodeAiSourcesQueryKey = (itemNodeId: MaybeRefOrGetter<string>,) => {
    return [
    'item_nodes',itemNodeId,'ai_sources'
    ] as const;
    }


export const getGetItemNodeAiSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getItemNodeAiSources>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(itemNodeId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemNodeAiSources>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetItemNodeAiSourcesQueryKey(itemNodeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemNodeAiSources>>> = ({ signal }) => getItemNodeAiSources(itemNodeId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(itemNodeId) !== null && toValue(itemNodeId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItemNodeAiSources>>, TError, TData>
}

export type GetItemNodeAiSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getItemNodeAiSources>>>
export type GetItemNodeAiSourcesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get Item Node AI Sources
 */

export function useGetItemNodeAiSources<TData = Awaited<ReturnType<typeof getItemNodeAiSources>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 itemNodeId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItemNodeAiSources>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetItemNodeAiSourcesQueryOptions(itemNodeId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Item Node AI Sources
 */
export const updateItemNodeAiSources = (
    itemNodeId: MaybeRefOrGetter<string>,
    itemNodeAiSourcesUpdateInput: MaybeRefOrGetter<ItemNodeAiSourcesUpdateInput>,
 signal?: AbortSignal
) => {
      itemNodeId = toValue(itemNodeId);
itemNodeAiSourcesUpdateInput = toValue(itemNodeAiSourcesUpdateInput);

      return axiosClient<ItemNodeAiSources>(
      {url: `/item_nodes/${itemNodeId}/ai_sources`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: itemNodeAiSourcesUpdateInput, signal
    },
      );
    }




export const getUpdateItemNodeAiSourcesMutationKey = () => ['updateItemNodeAiSources'] as const;

export const getUpdateItemNodeAiSourcesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItemNodeAiSources>>, TError,UpdateItemNodeAiSourcesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateItemNodeAiSources>>, TError,UpdateItemNodeAiSourcesMutationVariables, TContext> => {

const mutationKey = getUpdateItemNodeAiSourcesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItemNodeAiSources>>, UpdateItemNodeAiSourcesMutationVariables> = (props) => {
          const {itemNodeId,data} = props ?? {};

          return  updateItemNodeAiSources(itemNodeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemNodeAiSourcesMutationResult = NonNullable<Awaited<ReturnType<typeof updateItemNodeAiSources>>>
    export type UpdateItemNodeAiSourcesMutationBody = ItemNodeAiSourcesUpdateInput
    export type UpdateItemNodeAiSourcesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateItemNodeAiSourcesMutationVariables = {itemNodeId: string;data: ItemNodeAiSourcesUpdateInput}

    /**
 * @summary Update Item Node AI Sources
 */
export const useUpdateItemNodeAiSources = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItemNodeAiSources>>, TError,UpdateItemNodeAiSourcesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateItemNodeAiSources>>,
        TError,
        UpdateItemNodeAiSourcesMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateItemNodeAiSourcesMutationOptions(options), queryClient);
    }
